import React from "react";
import MCSReadonlyField from "../../../../components/MCSReadonlyField";
import { DateHelper } from "../../../../_helpers/DateHelper";
import FormControl from "@visa/vds/form-control";
import TextArea from "@visa/vds/textarea";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";

const OrderCancellationSection = (props) => {
  const order = props.order;
  return (
    <>
      <Row>
        <Col>
          <MCSReadonlyField
            label="Cancellation Date"
            text={DateHelper.ToLocaleDateString(order.cancellationDate)}
          />
          <MCSReadonlyField
            label="Canceled By"
            text={
              order.cancelledByUser.fullName +
              " (" +
              order.cancelledByUser.roleName +
              ")"
            }
          />
          <Typography className="vss-field-label">
            <b>Cancellation Reason:</b>
          </Typography>
          <FormControl position="left" space="fifty">
            <TextArea value={order.cancellationReason} readOnly={true} />
          </FormControl>
        </Col>
      </Row>
    </>
  );
};

export default OrderCancellationSection;
